import SubmitForm from "./SubmitForm";

type SubmitModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (summary: string) => void;
};

export default function SubmitModal({ open, onClose, onSubmit }: SubmitModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto bg-foreground-950/60 p-4 py-10 md:items-center">
      <div className="relative w-full max-w-lg rounded-lg border border-background-300 bg-background-50 p-5 md:p-7">
        <div className="mb-5 flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className="ri-quill-pen-line text-xl" />
            </span>
            <div>
              <h3 className="font-heading text-lg font-bold text-foreground-950">匿名投稿通道</h3>
              <p className="text-xs text-foreground-500">无需注册，全程不收集身份信息</p>
            </div>
          </div>
          <button
            type="button"
            aria-label="关闭投稿窗口"
            onClick={onClose}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <SubmitForm
          variant="modal"
          onSubmit={(summary) => {
            onSubmit(summary);
            if (!summary.startsWith("error:")) onClose();
          }}
        />
      </div>
    </div>
  );
}